<template>
    <section class="container bng-balance-operation bng-narrow-container">
        <section v-if="balance" class="section">
            <!--div v-if="type == 'deposit' && client.bonus.deposit && (!balance.bonus && !(bonus && bonus.playThrough) && !(bonus && bonus.depositBonusIsUsed))"
                 class="field column">
                <deposit-bonus-banner />
            </div-->
            <div class="payment-methods">
                <!-- payment system operation -->
                <div v-for="method of paymentMethods"
                    :key="`${method.name}-${method.methodId}`"
                    :class="[{ 'selected': selectedMethod === method }, { 'is-disabled': !method.enabled }, 'columns', 'notification', 'method',]"
                    @click="method.enabled && (selectedMethod = method)"
                    :title="`payment system.systems.${method.name}.name` | translate"
                >
                    <div :class="['labels', 'general', (method.settings.icon || method.name).split(' ').join('-')]"></div>
                    <div class="method-amount-block">
                        <div class="method-amount-row">
                            <template v-if="method.amountMin && method.amountMax">
                                {{ method.amountMin }}-{{ method.amountMax }}
                            </template>
                            <template v-else>-</template>
                        </div>
                    </div>
                </div>
                <!-- payment method parameters -->
                <div v-if="requiredInputParams.length" class="method-parameters">
                    <div class="">{{ "payment system.required fields" | translate }}</div>
                    <div v-for="inputParam of requiredInputParams" :key="inputParam.key" class="column field">
                        <div class="field">
                            <span class="hint has-text-grey is-italic">{{ `payment system.inputs.${inputParam.key}.label` | translate }}:</span>
                            <div class="field-body">
                                <div class="field">
                                    <div>
                                        <span v-if="inputParam.preHint" class="hint has-text-grey is-italic">{{ inputParam.preHint }}</span>
                                        <card-number v-if="inputParam.key === 'CardNumber'"
                                            :inputValue.sync="inputParam.value"
                                            :error-messages="errors.collect(`${selectedMethod.name}.${inputParam.key}`)"
                                            :data-vv-name="`${selectedMethod.name}.${inputParam.key}`"
                                            :class="[{ 'is-danger': errors.has(`${selectedMethod.name}.${inputParam.key}`) }, 'column']"
                                            type="text" />
                                        <card-date v-else-if="inputParam.key === 'CardDate'"
                                            :inputValue.sync="inputParam.value"
                                            :error-messages="errors.collect(`${selectedMethod.name}.${inputParam.key}`)"
                                            :data-vv-name="`${selectedMethod.name}.${inputParam.key}`"
                                            :class="[{ 'is-danger': errors.has(`${selectedMethod.name}.${inputParam.key}`) }, 'column']"
                                            type="text" />
                                        <email v-else-if="inputParam.key === 'Email'"
                                            :inputValue.sync="inputParam.value"
                                            :error-messages="errors.collect(`${selectedMethod.name}.${inputParam.key}`)"
                                            :data-vv-name="`${selectedMethod.name}.${inputParam.key}`"
                                            :class="[{ 'is-danger': errors.has(`${selectedMethod.name}.${inputParam.key}`) }, 'column']"
                                            type="text" />
                                        <template v-else-if="inputParam.key === 'PhoneNumber' && !(selectedMethod.settings && selectedMethod.settings.plainInputEditor)">
                                            <phone-number v-if="selectedMethod.name === 'Qiwi'"
                                                :inputValue.sync="inputParam.value"
                                                :error-messages="errors.collect(`${selectedMethod.name}.${inputParam.key}`)"
                                                :data-vv-name="`${selectedMethod.name}.${inputParam.key}`"
                                                :class="[{ 'is-danger': errors.has(`${selectedMethod.name}.${inputParam.key}`) }, 'column']"
                                                type="text" />
                                            <phone-number-mpesa v-else-if="selectedMethod.name === 'Mpesa'"
                                                :inputValue.sync="inputParam.value"
                                                :error-messages="errors.collect(`${selectedMethod.name}.${inputParam.key}`)"
                                                :data-vv-name="`${selectedMethod.name}.${inputParam.key}`"
                                                :class="[{ 'is-danger': errors.has(`${selectedMethod.name}.${inputParam.key}`) }]"
                                                type="text" />
                                            <phone-number-provider v-else
                                                :key="selectedMethod.name"
                                                :provider="selectedMethod.name"
                                                :inputValue.sync="inputParam.value"
                                                :defaultValue="player.phoneNumber"
                                                :error-messages="errors.collect(`${selectedMethod.name}.${inputParam.key}`)"
                                                :data-vv-name="`${selectedMethod.name}.${inputParam.key}`"
                                                :class="[{ 'is-danger': errors.has(`${selectedMethod.name}.${inputParam.key}`) }, 'column']"
                                                type="text" />
                                        </template>
                                        <template v-else-if="inputParam.key === 'Pin'">
                                            <input v-model="inputParam.value"
                                                :error-messages="errors.collect(`${selectedMethod.name}.${inputParam.key}`)"
                                                :data-vv-name="`${selectedMethod.name}.${inputParam.key}`"
                                                :class="[{ 'is-danger': errors.has(`${selectedMethod.name}.${inputParam.key}`) }, 'input column']"
                                                type="number"
                                                v-validate="inputParam.rules"
                                                @keyup.enter="submit();" />
                                        </template>
                                        <template v-else-if="inputParam.key === 'PinDestinationBranches'">
                                            <!-- choose branch (shop/cashier address) for withdrawal by pin from branch group -->
                                            <div v-for="br in selectedMethod.settings.branches" :key="br.id" class="control withdrawal-pin-address">
                                                <label class="radio">
                                                    <input v-model="withdrawalPinData.targetBranch" :value="br" :checked="withdrawalPinData.targetBranch && withdrawalPinData.targetBranch.id == br.id" type="radio" name="targetBranch">
                                                    {{ br.address || br.description || br.name || br.branch }}
                                                </label>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <input v-model="inputParam.value"
                                                :error-messages="errors.collect(`${selectedMethod.name}.${inputParam.key}`)"
                                                :data-vv-name="`${selectedMethod.name}.${inputParam.key}`"
                                                :class="[{ 'is-danger': errors.has(`${selectedMethod.name}.${inputParam.key}`) }, 'input column']"
                                                type="text"
                                                v-validate="inputParam.rules"
                                                @keyup.enter="submit();" />
                                            <span v-if="inputParam.hint" class="hint has-text-grey is-italic">{{ "payment system.example" | translate }}: {{ inputParam.hint }}</span>
                                        </template>
                                    </div>
                                    <span v-if="errors.has(`${selectedMethod.name}.${inputParam.key}`)" class="help is-danger">{{ errors.first(`${selectedMethod.name}.${inputParam.key}`) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fields-block field column">
                <!-- <div v-if="type === 'withdrawal'" class="field">
                    <div class="field">
                        <label>{{ "payment system.available" | translate }}:</label>
                        <div class="field-body">
                            <div class="field has-addons">
                                <p class="control column">
                                    <input class="input" :value="$options.filters.currency(balanceValue)" readonly />
                                </p>
                                <p class="control">
                                    <a class="button is-static">{{ balance.currency }}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <div class="field-body">
                            <div class="field">
                                <p class="control column">
                                    <a class="button is-success is-fullwidth" @click="amount = balanceInvariantValue">{{ "payment system.actions.withdraw all" | translate }}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="field">
                    <div class="field">
                        <span class="hint has-text-grey is-italic">{{ "payment system.amount" | translate }}:</span>
                        <div class="field-body">
                            <div class="field">
                                <p class="control column">
                                    <input v-model="amount"
                                        :error-messages="errors.collect('Amount')"
                                        :class="[{ 'is-danger': errors.has('Amount') }, 'input']"
                                        :disabled="!amountAvailable"
                                        :key="balanceValue"
                                        data-vv-name="Amount"
                                        type="text"
                                        v-validate.disable="`required|between:${selectedMethod ? selectedMethod.amountMin : 0},${selectedMethod ? selectedMethod.amountMax : 0}`"
                                        @input="handleAmountChange"
                                        @keyup.enter="submit();"
                                        onClick="this.select();" />
                                </p>
                                <span v-if="errors.has('Amount')" class="help is-danger">{{ errors.first("Amount") }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isUserProfileMustBeCompleted" class="message is-warning">
                <div class="message-body">
                    {{ "payment system.messages.userProfile" | translate }}
                    <router-link :to="{ name: 'profile', hash: '#settings' }" class="button is-small is-link">{{ "payment system.actions.fill profile" | translate }}</router-link>
                </div>
            </div>
            <div v-if="type == 'withdrawal' && (balance.bonus > 0 || (bonus && bonus.playThrough))" class="field notification is-warning content">
                <strong>{{ "payment system.bonus will be removed title" | translate }}</strong>
                <ul>
                    <li>{{ "payment system.bonus will be removed msg1" | translate }}</li>
                    <li>{{ "payment system.bonus will be removed msg2" | translate }}</li>
                </ul>
            </div>
            <!-- payment system errors -->
            <div v-if="errors.any()" class="field notification is-danger">
                <strong>{{ "payment system.errors" | translate }}:</strong>
                <ul>
                    <li v-for="error of errors.all()" :key="error">{{ error }}</li>
                </ul>
            </div>
            <!-- deposit pin errors -->
            <div v-if="depositPinData.error" class="field notification is-danger">
                <strong>{{ "payment system.errors" | translate }}:</strong>
                <ul>
                    <li v-if="depositPinData.error == 'pinNotFound'">{{ "payment system.activate-code.pin not found" | translate }}</li>
                    <li v-if="depositPinData.error == 'illegalPin'">{{ "payment system.activate-code.pin illegal" | translate }}</li>
                    <li v-if="depositPinData.error == 'alreadyActivated'">{{ "payment system.activate-code.pin already activated" | translate }}</li>
                    <li v-if="depositPinData.error == 'expired'">{{ "payment system.activate-code.pin expired" | translate }}</li>
                    <li v-if="depositPinData.error == 'activationError'">{{ "payment system.activate-code.pin activation error" | translate }}</li>
                    <li v-if="depositPinData.error == 'balanceNotUpdated'">{{ "payment system.activate-code.balance not updated" | translate }}</li>
                    <li v-if="depositPinData.error == 'alreadyHasActiveBonus'" v-html="$t('payment system.activate-code.already has active bonus', {'bonus_balance': bonusBalanceDescription, 'check_balances': checkBalancesLinkTemplate })"></li>
                    <li v-if="depositPinData.error == 'alreadyHasActivatedBonusPin'" v-html="$t('payment system.activate-code.already has activated bonus pin', {'next_activation': nextActivation })"></li>
                    <li v-if="depositPinData.error == 'bonusPinDisabled'">{{ "payment system.activate-code.bonus pin disabled" | translate }}</li>
                    <li v-if="depositPinData.failedAccessAttemptsLeft">{{ "payment system.activate-code.failed access warning" | translate }} {{ depositPinData.failedAccessAttemptsLeft }}</li>
                </ul>
            </div>
            <!-- rules agreement -->
            <div class="rules-agreement">
                <label class="checkbox">
                    <input v-model="agreedWithRules" type="checkbox" @change="$validator.reset();" />
                    <span v-html="$t(`payment system.agreement ${type}`, { url: mainRulesLink })"></span>
                </label>
                <router-link :to="{ name: 'rules-inner', params: { rule: mainRulesRef && mainRulesRef.name } }" target="_blank" style="vertical-align: middle;">
                    <span class="icon">
                        <i class="fas fa-external-link-alt"></i>
                    </span>
                </router-link>
            </div>
            <!-- submit/cancel buttons -->
            <div class="field is-grouped submit-buttons">
                <button :disabled="!agreedWithRules || isUserProfileMustBeCompleted" class="button-submit button is-link" @click="submit();">{{ action | translate }}</button>
                <div class="control">
                </div>
            </div>
            <!-- deposit pin bonus message -->
            <article v-if="depositPinData.bonus" class="message is-success">
                <div class="message-header">
                    <p>
                        {{ "payment system.activate-code.bonus title" | translate }}
                    </p>
                </div>
                <div class="message-body">
                    <p>
                        {{ "payment system.activate-code.bonus message1" | translate }}
                        <span class="has-text-success has-text-weight-semibold">{{ depositPinData.bonus.amount | currency(depositPinData.bonus.currency) }}!</span>
                    </p>
                    <p>
                        {{ "payment system.activate-code.bonus message2" | translate }}
                        <router-link :to="{name:'bonus-rules'}">{{ "payment system.activate-code.bonus message3" | translate }}</router-link>
                        {{ "payment system.activate-code.bonus message4" | translate }}
                    </p>
                </div>
            </article>
            <!-- deposit pin activated message -->
            <article v-if="depositPinData.isPinActivated" class="message is-success">
                <div class="message-header">
                    <p>
                        {{ "payment system.activate-code.pin activated title" | translate }}
                    </p>
                </div>
                <div class="message-body">
                    <p>
                        {{ "payment system.activate-code.pin activated message" | translate }}
                        <span class="has-text-success has-text-weight-semibold">{{ depositPinData.activeBalance.real | currency(depositPinData.activeBalance.currency) }}+{{ depositPinData.activeBalance.bonus | currency(depositPinData.activeBalance.currency) }}{{ "payment system.activate-code.bonus" | translate }}</span>
                    </p>
                </div>
            </article>
            <!-- deposit pin active balance changed message -->
            <article v-if="depositPinData.isActiveBalanceChanged" class="message is-warning">
                <div class="message-header">
                    <p>
                        {{ "payment system.activate-code.balance switched title" | translate }}
                    </p>
                </div>
                <div class="message-body">
                    <p>
                        {{ "payment system.activate-code.balance switched message" | translate }}
                        <span class="has-text-success has-text-weight-semibold">
                            <description :obj="depositPinData.activeBalance" />
                        </span>
                    </p>
                </div>
            </article>
            <!-- withdrawal pin information -->
            <article v-if="withdrawalPinData.pin" class="message is-success">
                <div class="message-header">
                    <p>
                        {{ "payment system.withdraw-by-code.success" | translate }}
                    </p>
                </div>
                <div class="message-body withdrawal-pin-info">
                    <p class="has-text-weight-bold">
                        {{ "payment system.withdraw-by-code.success amount" | translate }}
                    </p>
                    <p>
                        {{ withdrawalPinData.pin.value | currency(player.balance.currency) }}
                    </p>
                    <p class="has-text-weight-bold">
                        {{ "payment system.withdraw-by-code.code" | translate }}
                    </p>
                    <p class="has-background-warning">
                        {{ withdrawalPinData.pin.pin }}
                    </p>
                    <p class="has-text-weight-bold">
                        {{ "payment system.withdraw-by-code.code help" | translate }}
                    </p>
                    <p v-if="withdrawalPinData.pin.branch || pin.description">
                        <span class="has-text-weight-bold">{{ "payment system.withdraw-by-code.cashier" | translate }}:</span>
                        <description :obj="withdrawalPinData.pin.branchObj" />
                    </p>
                </div>
            </article>
        </section>
        <dimmer :value.sync="dimmer" />
        <div :class="[{ 'is-active': showModal }, 'modal']">
            <div class="modal-background">
            </div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">
                        {{ title | translate }}
                    </p>
                    <button class="delete" aria-label="close" @click="hideModal();"></button>
                </header>
                <section class="modal-card-body">
                    {{ "payment system.messages.errors.Approval" | translate }}
                </section>
                <footer class="modal-card-foot">
                    <button class="button is-success" style="margin-left: auto;" @click="hideModal();">Ok</button>
                </footer>
            </div>
        </div>
    </section>
</template>

<script>
    import Vue from 'vue';

    import balanceService from '../../../../../../_common/services/balance.service';
    import pinService from '../../../../../../_common/services/pin.service';
    import branchService from '../../../../../../_common/services/branch.service';
    import currencyService from '../../../../../../_common/services/currency.service';
    import paymentService from '../../../../../../_common/services/payment.service';
    import playerService from '../../../../../../_common/services/player.service';
    import ymService from '../../../../../../_common/services/ym.service';
    import gaService from '../../../../../../_common/services/ga.service';
    import rulesHelper from '../../../../../../_common/helpers/rules.helper';
    import utils from '../../../../../../_common/utils';

    import Dimmer from '../../../common/payments/dimmer.vue';
    import CardNumber from '../../../common/payments/card-number.vue';
    import CardDate from '../../../common/payments/card-date.vue';
    import Email from '../../../common/payments/email.vue';
    import PhoneNumber from '../../../common/payments/phone-number.vue';
    import PhoneNumberMpesa from '../../../common/payments/phone-number-mpesa.vue';
    import PhoneNumberProvider from '../../../common/payments/phone-number-provider.vue';
    import Description from '../../../common/description/description.vue';
    //import DepositBonusBanner from "../banners/deposit-bonus.vue";    

    const balancesMap = {
        deposit: {
            name: 'real',
            title: 'payment system.deposit',
            action: 'payment system.actions.deposit'
        },
        withdrawal: {
            name: 'real',
            title: 'payment system.withdrawal',
            action: 'payment system.actions.withdraw'
        }
    };

    const getEmptyDepositPinData = () => ({
        error: null,
        isPinActivated: false,
        isActiveBalanceChanged: false,
        activeBalance: null,
        failedAccessAttemptsLeft: null,
        bonusSubscription: null,
        bonus: null,
        bonusBalance: null,
        activeBonus: null,
        availableBonuses: [],
        declinedBonusesMessages: [],
        preferredBonusType: null
    });

    const getEmptyWithdrawalPinData = () => ({
        hasErrors: false,
        pin: null,
        targetBranch: null
    });

    export default {
        name: "balance-operation",
        props: ['typeOperation'],
        components: { Dimmer, CardNumber, CardDate, Email, PhoneNumber, PhoneNumberMpesa, PhoneNumberProvider, Description },
        $_veeValidate: { validator: "new" },
        data: () => ({
            profile: null,
            amount: 0,
            balance: null,
            bonus: null,
            paymentMethods: [],
            selectedMethod: null,
            mainRulesRef: null,
            agreedWithRules: false,
            methodsLoading: false,
            conversionLoading: false,
            dimmer: null,
            showModal: false,
            depositPinData: getEmptyDepositPinData(),
            withdrawalPinData: getEmptyWithdrawalPinData()
        }),
        computed: {
            client: function() {
                return Vue.state.client.get();
            },
            player: function() {
                return Vue.state.player.get();
            },
            balanceId: function() {
                return this.player.balance.id;
            },
            balanceChanged: function() {
                return this.balanceId && this.player.balance.real;
            },
            type: function() {
                return this.$route.params.type || this.$props.typeOperation;
            },
            lang: function() {
                return Vue.state.lang.currentLang;
            },
            balanceValue: function() {
                return this.balance ? this.balance[balancesMap[this.type].name] : 0;
            },
            balanceInvariantValue: function() {
                return this.balance ? currencyService.formatInvariant(this.balanceValue, this.balance.currency) : 0;
            },
            withdrawalMin: function() {
                return this.type === "withdrawal"
                    && this.paymentMethods.length
                    && this.paymentMethods.slice().sort((a, b) => (a.amountMin > b.amountMin ? 1 : b.amountMin > a.amountMin ? -1 : 0))[0].amountMin;
            },
            profileFields() {
                return this.client && this.client.view.profile.profileFields;
            },
            isUserProfileCompleted: function() {
                return playerService.checkProfileCompleted(this.profile, this.profileFields);
            },
            isUserProfileMustBeCompleted: function() {
                return this.type === "withdrawal"
                    && (this.selectedMethod && this.selectedMethod.name !== "Pin")
                    && this.paymentMethods.length
                    && !this.isUserProfileCompleted;
            },
            amountAvailable: function() {
                if (this.selectedMethod && this.selectedMethod.name === "Pin") {
                    return this.type == "withdrawal";
                }

                return !this.isUserProfileMustBeCompleted
                    && !this.methodsLoading
                    && this.paymentMethods.length > 0
                    && (this.type === "deposit"
                        || (this.type === "withdrawal"
                            && this.balanceValue
                            && this.paymentMethods.some(item => item.amountMin <= this.balanceInvariantValue)));
            },
            title: function() {
                return balancesMap[this.type].title;
            },
            action: function() {
                return balancesMap[this.type].action;
            },
            requiredInputParams() {
                if (!this.selectedMethod) {
                    return [];
                }

                return Object.keys(this.selectedMethod.inputParams).map(key => {
                    const requiredParam = {
                        key,
                        name: key,
                        preHint: null,
                        hint: null,
                        value: null,
                        rules: { required: true }
                    };
                    const type = this.selectedMethod.inputParams[key];
                    switch (type) {
                        case "YandexNumber":
                            requiredParam.rules.regex = /^[0-9]{11,20}$/;
                            requiredParam.hint = this.$t("payment system.inputs.YandexNumber.hint");
                            break;
                        case "WebmoneyNumber":
                            requiredParam.rules.regex = /^[ZER][0-9]{12}$/;
                            break;
                        case "Pin":
                            requiredParam.rules.regex = /^[0-9]{8}$/;
                            requiredParam.hint = this.$t("payment system.inputs.Pin.hint");
                            break;
                    }

                    return requiredParam;
                });
            },
            isPinAvailable: function() {
                return (this.type === "deposit" && this.client.paymentSystem.pinDepositAllowed) || (this.type === "withdrawal" && this.client.paymentSystem.pinWithdrawalAllowed);
            },
            mainRulesLink() {
                return this.$router.resolve({ name: "rules", params: { rule: this.mainRulesRef && this.mainRulesRef.name } }).href;
            }
        },
        watch: {
            type: function() {
                this.reset();
            },
            balanceId: function() {
                this.reset();
            },
            selectedMethod: function() {
                this.amount = 0;
            },
            balanceChanged: function() {
                this.reset();
            },
            lang: function(value) {
                this.$validator.localize("_");
                this.$validator.localize(value);
            }
        },
        async created() {
            this.mainRulesRef = await rulesHelper.getMainRulesRef(this.lang);
        },
        async mounted() {
            await this.reset();
            this.trackAnalyticsStep(1);
        },
        methods: {
            async reset() {
                this.dimmer.show();
                this.amount = 0;
                this.selectedMethod = null;
                this.errors.clear();
                this.$validator.reset();
                this.depositPinData = getEmptyDepositPinData();
                this.withdrawalPinData = getEmptyWithdrawalPinData();

                await this.loadBalance();
                await this.loadBonus();
                await this.loadUserProfile();
                await this.loadPaymentMethods();

                this.checkErrors();
                this.dimmer.hide();
            },
            async loadUserProfile() {
                this.profile = await playerService.getProfile();
            },
            async loadBalance() {
                this.balance = await balanceService.getBalanceAsync(this.balanceId);
            },
            async loadBonus() {
                this.bonus = await balanceService.getBonuses();
            },
            async loadPaymentMethods() {
                if (!this.balance) {
                    return;
                }

                this.methodsLoading = true;
                this.paymentMethods.length = 0;

                const methods = await paymentService.getPaymentMethods(this.balanceId, this.type);
                methods && methods.length && this.paymentMethods.push(...methods);
                this.selectedMethod = null;
                this.processPaymentMethods();
                this.methodsLoading = false;
            },
            processPaymentMethods() {
                const getAmountMin = this.type === "deposit"
                    ? method => method.name === "Pin" ? 0 : method.amountMin || currencyService.getMinimal(this.balance.currency)
                    : method => method.amountMin || currencyService.getMinimal(this.balance.currency);

                const getAmountMax = this.type === "deposit"
                    ? method => method.name === "Pin" ? 0 : method.amountMax
                    : method => method.amountMax || this.balanceInvariantValue;

                this.paymentMethods.forEach(item => {
                    item.amountMin = getAmountMin(item);
                    item.amountMax = getAmountMax(item);
                    item.settings = item.settings || {};
                    item.enabled = item.name === "Pin" && this.type === "deposit" || item.amountMin <= item.amountMax
                });

                const selectedMethod = this.selectedMethod;
                this.selectedMethod = null;
                this.selectedMethod = selectedMethod || this.paymentMethods.find(item => item.enabled);
            },
            checkErrors() {
                this.errors.clear();

                if (!this.isPinAvailable && !this.paymentMethods.length) {
                    this.addError("NoMethodsAvailable", "payment system.messages.errors.NoMethodsAvailable");
                }

                if (this.type === "withdrawal" && !this.balanceValue) {
                    this.addError("AmountAvailable", "payment system.messages.errors.Amount.no funds for withdrawal");
                }
            },
            async submit() {
                this.errors.clear();
                const isValid = await this.$validator.validateAll().then(isValid => isValid);
                if (isValid) {

                    this.trackAnalyticsStep(2);

                    if (this.selectedMethod.name === "Pin" || this.selectedMethod.settings.pin) {
                        if (this.type == "deposit") {
                            await this.depositPin();
                        }
                        else if (this.type == "withdrawal") {
                            await this.withdrawPin();
                        }
                        else {
                            console.error(`Unexpected operation type ${this.type} for pin`);
                        }
                    }
                    else {
                        await this.submitToPaymentSystem();
                    }
                }
            },
            async submitToPaymentSystem() {
                this.dimmer.show();
                const result = await paymentService.createOperationAsync({
                    amount: this.amount,
                    currencyCode: this.balance.currency,
                    paymentMethodId: this.selectedMethod.methodId,
                    inputParams: this.requiredInputParams.reduce((a, b) => ({ ...a, [b.key]: b.value }), {}),
                    operationType: this.type,
                    balanceId: this.balance.id
                });
                if (result.redirection) {
                    const form = document.createElement("form");
                    form.setAttribute("action", result.redirection.url);
                    form.setAttribute("method", result.redirection.method);
                    result.redirection.params.forEach(item => {
                        const input = document.createElement("input");
                        input.setAttribute("type", "hidden");
                        input.setAttribute("name", item.key);
                        input.setAttribute("value", item.value);
                        form.appendChild(input);
                    });

                    document.body.appendChild(form);
                    form.submit();
                }
                else {
                    this.handleErrorResult(result);
                    this.dimmer.hide();
                }
            },
            async depositPin() {
                this.dimmer.show();
                const pincode = this.requiredInputParams[0].value;
                this.depositPinData.error = null;
                this.depositPinDatafailedAccessAttemptsLeft = null;
                this.depositPinData.isPinActivated = false;
                this.depositPinData.isActiveBalanceChanged = false;
                Vue.state.player.unsubscribePushMessages(this.depositPinData.bonusSubscription);
                this.depositPinData.bonus = null;

                this.depositPinData.bonusSubscription = Vue.state.player.subscribePushMessages(this.showBonusMessage);
                const result = await pinService.apply(pincode, this.depositPinData.preferredBonusType);
                this.depositPinData.error = result.error;
                this.depositPinData.failedAccessAttemptsLeft = result.failedAccessAttemptsLeft;
                this.depositPinData.activeBonus = result.activeBonus;
                this.depositPinData.availableBonuses = result.availableBonuses;

                if (result.isSuccess) {
                    const prevBalance = utils.clone(Vue.state.player.get().balance);
                    Vue.state.player.setBalance(await balanceService.getActiveBalance());
                    this.clearDepositPinData();
                    this.depositPinData.activeBalance = await balanceService.getActiveBalance();
                    if (!prevBalance || this.depositPinData.activeBalance.id !== prevBalance.id) {
                        this.depositPinData.isActiveBalanceChanged = true;
                    }

                    this.depositPinData.isPinActivated = true;
                    this.amount = 0;
                }
                else {
                    Vue.state.player.unsubscribePushMessages(this.depositPinData.bonusSubscription);
                    if (this.depositPinData.error == "pinNotFound" && this.depositPinData.failedAccessAttemptsLeft < 1) {
                        await playerService.logout();
                        this.clearDepositPinData();
                        this.$router.push("/");
                    }
                    else {
                        this.depositPinData.bonusBalance = await balanceService.getBonusBalance();
                    }
                }

                this.trackAnalyticsResult(result.isSuccess ? "pin_success" : "pin_error");
                this.dimmer.hide();
            },
            async withdrawPin() {
                this.dimmer.show();
                const metadata = this.requiredInputParams.filter(({ key }) => key !== "PinDestinationBranches").reduce((a, b) => ({ ...a, [b.key]: b.value }), {});
                const withdrawal = await balanceService.withdraw(currencyService.toSource(this.amount, this.player.balance.currency), this.withdrawalPinData.targetBranch && this.withdrawalPinData.targetBranch.branch, metadata);
                if (withdrawal.isSuccess) {
                    const p = withdrawal.pin;
                    p.branchObj = await branchService.getBranch(p.branch);
                    p.branchObj.currency = p.currency;
                    this.withdrawalPinData.pin = p;
                    this.amount = 0;
                }
                else {
                    this.handleErrorResult(withdrawal);
                }

                this.trackAnalyticsResult(withdrawal.isSuccess ? "pin_success" : "pin_error");
                this.dimmer.hide();
            },
            handleErrorResult(result) {
                if (result.error === "InternalError") {
                    this.addError(result.error, "payment system.messages.errors.internalError");
                }
                else {
                    if (result.errorData.some(({ key }) => key === "Approval")) {
                        this.showModal = true;
                    }
                    else {
                        result.errorData.forEach(({ key, message, extraParams }) => this.addError(key, `payment system.messages.errors.${key}.${message}`, extraParams));
                    }
                }
            },
            clearDepositPinData() {
                this.requiredInputParams[0].value = "";
                this.error = null;
                this.failedAccessAttemptsLeft = null;
                this.isPinActivated = false;
                this.isActiveBalanceChanged = false;
            },
            getCurrency(currencyId) {
                return Vue.state.currencies.getCurrency(currencyId);
            },
            addError(field, messageKey, extraParams) {
                const localize = () => this.$t(messageKey, extraParams || []);
                this.errors.add({ field, msg: localize(), regenerate: localize });
            },
            hideModal() {
                this.showModal = false;
                this.$router.push({ name: 'profile' });
            },
            showBonusMessage(message) {
                if (message.type.includes("Declined")) {
                    this.declinedBonusesMessages.push(message);
                    return;
                }

                if (!message.type.includes("BonusDeposited") && !message.type.includes("BonusCouponDeposited")) {
                    return;
                }

                this.bonus = { amount: message.amount, currency: message.currency };
            },
            cancelActivation() {
                this.clear();
                this.$router.push({ name: 'profile', hash: '#withdrawal' });
            },
            getBonusItemStyle(bonusType) {
                if (!this.preferredBonusType) {
                    return;
                };

                if (this.preferredBonusType != bonusType) {
                    return { "text-decoration": "line-through" };
                }
            },
            isBonusTypeUnselected(bonusType) {
                return this.preferredBonusType && this.preferredBonusType != bonusType;
            },
            getMethodSystems(method) {
                return method.settings.systems
                    && method.settings.systems
                        .split("|")
                        .filter(item => item)
                        .map(item => {
                            const key = `payment system.systems.${item}.name`;
                            const result = this.$t(key);
                            return key === result ? item : result;
                        })
                        .join(", ");
            },
            handleAmountChange() {
                if (this.selectedMethod.name === "Mpesa") {
                    this.amount = this.amount.toString().replace(/\D/g, "");
                }
            },
            trackAnalyticsStep(step) {
                ymService.send("reachGoal", `${this.type.toUpperCase()} STEP ${step}`);
                gaService.send("paymentsystem", `ps_${this.type}_step_${step}`, `${this.type}${step}`);
            },
            trackAnalyticsResult(result) {
                ymService.send("reachGoal", `${this.type.toUpperCase()} RESULT ${result.toUpperCase() }`);
                gaService.send("paymentsystem", `ps_${this.type}_${result}`, `${this.type}3`);
            }
        },
        beforeDestroy() {
            Vue.state.player.unsubscribePushMessages(this.depositPinData.bonusSubscription);
        }
    };
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/balance-operation/balance-operation.vue